import { forgotPassword } from "./../api/post";

const AuthorizeEmail = async (email: string, token: string): Promise<void> => {
  await forgotPassword(email, token).catch((error) => {
    throw error;
  });
};

export default AuthorizeEmail;
